import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  private static MIME_TYPES_SHOW_IN_BROWSER = [
    'application/pdf',
    'image/jpeg',
    'image/png'
  ];

  public async showOrDownloadFile(fileDownload$: Observable<HttpResponse<Blob>>): Promise<boolean> {
    let newWindow: Window;
    try {
      newWindow = window.open('', '_blank');
      newWindow.document.write('Dokument wird geladen...');
      const document = await firstValueFrom(fileDownload$);
      if (FileDownloadService.MIME_TYPES_SHOW_IN_BROWSER.some(mimeType => mimeType === document.body.type)) {
        newWindow.location.href = URL.createObjectURL(document.body);
      } else {
        newWindow.close();
        const fileName = this.getFileNameFromHttpResponse(document);
        FileSaver.saveAs(document.body, fileName);
      }

    } catch (e) {
      if (newWindow) {
        newWindow.close();
      }
      return false;
    }
    return true;
  }

  public downloadBlobFromParam(blob: Blob, filename: string): void {
    try {
      FileSaver.saveAs(blob, filename);
    } catch (e) {
    }
  }

  public getFileNameFromHttpResponse(response: HttpResponse<Blob>) {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get('content-disposition');
      const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = fileNameRegex.exec(contentDisposition);
      if (matches?.[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    } catch (e) {
    }
    return filename;
  }
}
